/* eslint-disable no-restricted-syntax */
/* -------------------------------------------------------------------------- */
/*                                 step wizard                                */
/* -------------------------------------------------------------------------- */
// ...existing code...
const wizardInit = () => {
  const { getData } = window.phoenix.utils;

  const selectors = {
    WIZARDS: '[data-theme-wizard]',
    TOGGLE_BUTTON_EL: '[data-wizard-step]',
    FORMS: '[data-wizard-form]', // Should point to the single <form>
    PASSWORD_INPUT: '[data-wizard-password]',
    CONFIRM_PASSWORD_INPUT: '[data-wizard-confirm-password]',
    NEXT_BTN: '[data-wizard-next-btn]',
    PREV_BTN: '[data-wizard-prev-btn]',
    FOOTER: '[data-wizard-footer]'
  };

  const events = {
    // SUBMIT: 'submit', // No longer dispatching custom submit for navigation
    SHOW: 'show.bs.tab',
    SHOWN: 'shown.bs.tab',
    CLICK: 'click'
  };

  const wizards = document.querySelectorAll(selectors.WIZARDS);

  wizards.forEach(wizard => {
    const tabToggleButtonEl = wizard.querySelectorAll(
      selectors.TOGGLE_BUTTON_EL
    );
    const form = wizard.querySelector(selectors.FORMS); // Assuming one form for the wizard
    const passwordInput = wizard.querySelector(selectors.PASSWORD_INPUT);
    const confirmPasswordInput = wizard.querySelector(
      selectors.CONFIRM_PASSWORD_INPUT
    );
    const nextButton = wizard.querySelector(selectors.NEXT_BTN);
    const prevButton = wizard.querySelector(selectors.PREV_BTN);
    const wizardFooter = wizard.querySelector(selectors.FOOTER);
    const initialNextButtonText = nextButton ? nextButton.innerHTML : 'Next';

    // const submitEvent = new Event(events.SUBMIT, { // No longer needed for navigation
    //   bubbles: true,
    //   cancelable: true
    // });
    const hasWizardModal = wizard.hasAttribute('data-wizard-modal-disabled');

    const tabs = Array.from(tabToggleButtonEl).map(item => {
      return window.bootstrap.Tab.getOrCreateInstance(item);
    });

    let count = 0; // Index of the current active tab
    // let showEvent = null; // 'show.bs.tab' event is passed directly to its handler

    // Remove or refactor the old global form submit listener
    // The original: forms.forEach(form => { form.addEventListener(events.SUBMIT, e => { ... }) });
    // This was problematic. Validation is now more targeted.

    if (nextButton && form) {
      nextButton.addEventListener(events.CLICK, function (clickEvent) {
        const isFinalSubmitAttempt = (count === tabToggleButtonEl.length - 2); // Button shows "Submit"

        if (isFinalSubmitAttempt) {
          // Action for the "Submit" button (on the tab before "Done")
          // 1. Validate the current tab's fields
          const currentTabPaneId = tabToggleButtonEl[count].getAttribute('href') || tabToggleButtonEl[count].dataset.bsTarget;
          const currentTabPane = document.querySelector(currentTabPaneId);
          let currentTabIsValid = true;

          if (form.classList.contains('needs-validation') && currentTabPane) {
            form.classList.remove('was-validated'); // Clear global validation state
            const inputsToValidate = currentTabPane.querySelectorAll('input:not([type="hidden"]), select, textarea');
            inputsToValidate.forEach(input => input.setCustomValidity('')); // Clear previous custom messages

            // Password confirmation check if relevant fields are in the current tab
            if (passwordInput && confirmPasswordInput && currentTabPane.contains(passwordInput) && currentTabPane.contains(confirmPasswordInput)) {
              if (passwordInput.value !== confirmPasswordInput.value) {
                confirmPasswordInput.setCustomValidity('Passwords do not match.');
              } else {
                confirmPasswordInput.setCustomValidity('');
              }
            }
            // Terms and conditions check if relevant
            const termsCheckbox = currentTabPane.querySelector('#bootstrap-wizard-validation-wizard-checkbox');
            if (termsCheckbox && termsCheckbox.required && !termsCheckbox.checked) {
              termsCheckbox.setCustomValidity('You must accept the terms and conditions.');
            } else if (termsCheckbox) {
              termsCheckbox.setCustomValidity('');
            }

            inputsToValidate.forEach(input => {
              if (!input.checkValidity()) {
                currentTabIsValid = false;
              }
            });
            if (termsCheckbox && termsCheckbox.required && !termsCheckbox.checkValidity()) {
              currentTabIsValid = false;
            }
          }

          if (!currentTabIsValid) {
            clickEvent.preventDefault(); // Prevent form submission
            form.classList.add('was-validated'); // Show errors for the current tab
            return; // Stop processing
          }

          // Current tab is valid. Now validate the entire form for final submission.
          form.classList.remove('was-validated'); // Reset for full form validation display
          if (!form.checkValidity()) {
            clickEvent.preventDefault(); // Prevent form submission
            form.classList.add('was-validated'); // Show all errors across the form
          } else {
            // Form is valid, allow the `type="submit"` to proceed.
            // For AJAX submissions, you would preventDefault and handle submission here,
            // then call tabs[count + 1].show() on success.
            // For standard HTML submit, the page will reload/redirect.
          }
        } else if (count + 1 < tabs.length) {
          // Standard "Next" button click
          clickEvent.preventDefault(); // Prevent default button submission
          tabs[count + 1].show(); // Attempt to show next tab (triggers 'show.bs.tab' for validation)
        }
      });
    }

    if (prevButton) {
      prevButton.addEventListener(events.CLICK, () => {
        if (count > 0) {
          // count -= 1; // count will be updated by SHOWN event
          tabs[count - 1].show();
        }
      });
    }

    if (tabToggleButtonEl.length && form) {
      tabToggleButtonEl.forEach((tabButton, targetTabIndex) => {
        tabButton.addEventListener(events.SHOW, e => { // e is the 'show.bs.tab' event
          // 'count' is the index of the current active tab (source)
          // 'targetTabIndex' is the index of the tab to be shown (destination)
          if (targetTabIndex > count) { // Moving to a NEXT tab
            const currentTabPaneId = tabToggleButtonEl[count].getAttribute('href') || tabToggleButtonEl[count].dataset.bsTarget;
            const currentTabPane = document.querySelector(currentTabPaneId);

            if (currentTabPane && form.classList.contains('needs-validation')) {
              let currentTabIsValid = true;
              const inputsToValidate = currentTabPane.querySelectorAll('input:not([type="hidden"]), select, textarea');

              form.classList.remove('was-validated'); // Clear global validation state first
              inputsToValidate.forEach(input => input.setCustomValidity('')); // Clear previous custom messages for this tab

              // Password confirmation check
              if (passwordInput && confirmPasswordInput && currentTabPane.contains(passwordInput) && currentTabPane.contains(confirmPasswordInput)) {
                if (passwordInput.value !== confirmPasswordInput.value) {
                  confirmPasswordInput.setCustomValidity('Passwords do not match.');
                } else {
                  confirmPasswordInput.setCustomValidity('');
                }
              }
              // Terms and conditions check
              const termsCheckbox = currentTabPane.querySelector('#bootstrap-wizard-validation-wizard-checkbox');
              if (termsCheckbox && termsCheckbox.required && !termsCheckbox.checked) {
                termsCheckbox.setCustomValidity('You must accept the terms and conditions.');
              } else if (termsCheckbox) {
                termsCheckbox.setCustomValidity('');
              }

              inputsToValidate.forEach(input => {
                if (!input.checkValidity()) {
                  currentTabIsValid = false;
                }
              });
              if (termsCheckbox && termsCheckbox.required && !termsCheckbox.checkValidity()) {
                currentTabIsValid = false;
              }

              if (!currentTabIsValid) {
                e.preventDefault(); // Prevent tab switch
                form.classList.add('was-validated'); // Add 'was-validated' to show errors for checked fields
              } else {
                form.classList.remove('was-validated'); // Tab is valid, ensure validation styles are cleared
              }
            }
          } else {
            // Moving backward or initial load, clear validation state from the form
            form.classList.remove('was-validated');
          }
        });

        tabButton.addEventListener(events.SHOWN, () => {
          count = targetTabIndex; // Update current active tab index
          if (form) form.classList.remove('was-validated'); // Clear validation styles when a tab is successfully shown

          // can't go back tab (original logic)
          if (count === tabToggleButtonEl.length - 1 && !hasWizardModal) {
            tabToggleButtonEl.forEach(tab => {
              tab.setAttribute('data-bs-toggle', 'modal');
              tab.setAttribute('data-bs-target', '#error-modal');
            });
          }
          // add done class (original logic)
          for (let i = 0; i < count; i += 1) {
            tabToggleButtonEl[i].classList.add('done');
            if (i > 0) {
              tabToggleButtonEl[i - 1].classList.add('complete');
            }
          }
          // remove done class (original logic)
          for (let j = count; j < tabToggleButtonEl.length; j += 1) {
            tabToggleButtonEl[j].classList.remove('done');
            if (j > 0) {
              tabToggleButtonEl[j - 1].classList.remove('complete');
            }
          }

          // Change Next button text based on the current step
          if (nextButton) {
            if (count === tabToggleButtonEl.length - 2) { // If on the second-to-last step (before "Done")
              nextButton.innerHTML = 'Submit';
            } else { // For all other steps
              nextButton.innerHTML = initialNextButtonText;
            }
          }

          // card footer remove at last step (Done tab)
          if (wizardFooter) {
            if (count >= tabToggleButtonEl.length - 1) { // Adjusted to hide on the "Done" tab itself
              wizardFooter.classList.add('d-none');
            } else {
              wizardFooter.classList.remove('d-none');
            }
          }


          // prev-button removing
          if (prevButton) {
            // Show prev button if not on the first step and not on the "Done" tab
            if (count > 0 && count < tabToggleButtonEl.length - 1) {
              prevButton.classList.remove('d-none');
            } else {
              prevButton.classList.add('d-none');
            }
          }
        });
      });
    }
  });
};
// ...existing code...

export default wizardInit;
